import { useCallback } from 'react';
import { PickupLocationProximityThresholdMeters } from '~/apps/smartsend/lib/helpers/useQuoteHelper';
import { useSmartSendApi } from '~/lib/api/smartsend/use-smartsend-api';

export const useGetClosestLocationForDelivery = () => {
  const { getDropLocations } = useSmartSendApi();
  const getClosestLocationForDelivery = useCallback(
    async (provider: string, accountId: string, locationProvider: string, country: string, location: string) => {
      try {
        const dropLocations = await getDropLocations(
          provider,
          accountId,
          locationProvider,
          country,
          location,
          'AcceptsDelivery'
        );
        if (
          dropLocations.success &&
          dropLocations.result.DropLocations.filter(
            (x) => x.AcceptsDelivery && x.Distance <= PickupLocationProximityThresholdMeters
          ).length > 0
        ) {
          return dropLocations.result.DropLocations[0];
        } else {
          return null;
        }
      } catch (e) {
        console.error('Error checking drop locations for shop delivery', e);
        return null;
      }
    },
    [getDropLocations]
  );

  return { getClosestLocationForDelivery } as const;
};
